import React, { ReactElement, useEffect, useState } from 'react';
import { PredkladatelInput } from 'slovlex-idsk-react-components';
import useSearchOrganizacie from '../../../../hooks/useSearchOrganizacie';
import {
  MAX_MULTISELECT_RESULT,
  SHOW_ALL_MAX_RESULT,
} from '../../../../constants/MultiSelectConstant';
import Predkladatel from '../../../../model/legislativnyMaterial/Predkladatel';
import useZodpovednyPredkladatelList from '../../../../hooks/useZodpovednyPredkladatelList';
import LegislativnyMaterialDetail
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface PredkladatelProps {
  legMaterialDetail?: LegislativnyMaterialDetail;
  selectedItem: Predkladatel,
  setSelectedItem: (newSelectedItemList: Predkladatel) => void,
  getFieldErrorMessage: (fieldName: string) => string;
  predkladatelInitMap?: Map<string, Array<{ uuid: string, nazov: string }>>;
  hint?: string,
}

const ZodpovednyPredkladatelComponent = ({
  selectedItem,
  setSelectedItem,
  getFieldErrorMessage,
  predkladatelInitMap,
  hint,
  legMaterialDetail,
}: PredkladatelProps): ReactElement => {
  const [predkladatelMap, setPredkladatelMap] = useState(predkladatelInitMap);
  const [organizaciaSearch, setOrganizaciaSearch] = useState<string>('');
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);
  const [reloadPredkladatelData, setReloadPredkladatelData] = useState(false);

  const {
    organizacie,
    organizacieStatus,
  } = useSearchOrganizacie({
    typ: undefined,
    ids: [],
    ldap: true,
    legislativna: true,
    platna: true,
    nazov: selectedItem?.organizacia?.nazov || organizaciaSearch,
    limit,
  });

  const {
    pouzivatelia: predkladatelListData,
    pouzivateliaStatus,
  } = useZodpovednyPredkladatelList(
    reloadPredkladatelData,
    setReloadPredkladatelData,
    selectedItem.organizacia?.ldapUuid,
  );

  useEffect(() => {
    if (selectedItem.organizacia) {
      if (!predkladatelMap.has(selectedItem.organizacia?.uuid)) {
        setReloadPredkladatelData(true);
      }
    }
  }, [predkladatelMap, selectedItem.organizacia]);

  useEffect(() => {
    if (pouzivateliaStatus?.finished && !pouzivateliaStatus.loading) {
      if (!predkladatelMap.has(selectedItem.organizacia?.uuid)) {
        const updatedMap = predkladatelMap;
        updatedMap.set(selectedItem.organizacia?.uuid, predkladatelListData);
        setPredkladatelMap(updatedMap);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [predkladatelListData, pouzivateliaStatus, predkladatelMap]);

  return (
    <>
      {organizacie && (
        <PredkladatelInput
          loadingOrganizacia={organizacieStatus.loading}
          initialValues={legMaterialDetail ? [{
            organizacia: legMaterialDetail.zodpovednaInstitucia,
            predkladatel: legMaterialDetail.zodpovednyPredkladatel,
          }] : []}
          handleShowAll={() => {
            setLimit(SHOW_ALL_MAX_RESULT);
          }}
          withShowAllButton={(limit === MAX_MULTISELECT_RESULT
              && organizacie.length === MAX_MULTISELECT_RESULT)
            || (limit === SHOW_ALL_MAX_RESULT && organizacie.length <= MAX_MULTISELECT_RESULT)}
          searchText={organizaciaSearch}
          setSearchText={(text) => {
            setOrganizaciaSearch(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          error={getFieldErrorMessage('zodpovednyPredkladatel')}
          className="create-leg-material__zodpovedni-predkladatelia"
          label="Zodpovedný predkladateľ"
          hint={hint}
          required
          multiSelect={false}
          organizaciaData={organizacie}
          loadingPredkladatel={pouzivateliaStatus.loading}
          predkladatelData={predkladatelMap}
          selectedItemList={[selectedItem]}
          setSelectedItemList={((itemList) => {
            const item = itemList[itemList.length - 1];
            if (item.organizacia?.uuid !== selectedItem.organizacia?.uuid) {
              item.predkladatel = null;
            }
            setSelectedItem(item);
          })}
          width="full"
        />
      )}
    </>
  );
};

export default ZodpovednyPredkladatelComponent;
